module.exports = require('./apiCheck');



/** WEBPACK FOOTER **
 ** ../~/jshint-loader!./index.js
 **/